document.addEventListener('DOMContentLoaded', function () {

    const button = document.querySelector('.js-gallery-more');
    if (!button) return;

    const items = document.querySelectorAll('.gallery__item');
    const step = 9;
    let visibleCount = 9;

    button.addEventListener('click', function () {

        let revealed = 0;

        items.forEach(item => {
            if (item.classList.contains('is-hidden') && revealed < step) {
                item.classList.remove('is-hidden');
                revealed++;
            }
        });

        visibleCount += revealed;

        if (visibleCount >= items.length) {
            button.remove();
        }
    });

});